import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DataTablesModule } from 'angular-datatables';
import { CardModule } from 'src/app/content/partials/general/card/card.module';
import { RouterModule } from '@angular/router';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { DatatableComponent } from './components/datatable/datatable.component';
import { MatSliderModule } from '@angular/material/slider';
import { StartEndDateComponent } from './components/start-end-date/start-end-date.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DropdownComponent } from './components/dropdown/dropdown.component';
import { ExpenseBasicDetailsComponent } from '../content/corp-employee/expense-info/expense-basic-details/expense-basic-details.component';
import { ExpenseApprovalDetailsComponent } from '../content/corp-employee/expense-info/expense-approval-details/expense-approval-details.component';
import { ExpenseInvoiceDetailsComponent } from '../content/corp-employee/expense-info/expense-invoice-details/expense-invoice-details.component';
import { ExpensePaymentDetailsComponent } from '../content/corp-employee/expense-info/expense-payment-details/expense-payment-details.component';
import { ExpenseReimbursementDetailsComponent } from '../content/corp-employee/expense-info/expense-reimbursement-details/expense-reimbursement-details.component';
import { PriceBreakupGroupComponent } from './price-breakup-group/price-breakup-group.component';
import { PriceBreakupBanquetComponent } from './price-breakup-banquet/price-breakup-banquet.component';
import { SearchModalComponent } from './search-modal/search-modal.component';
// import { PriceBreakupComponent } from './price-breakup/price-breakup.component';
import { NgxSliderModule } from '@angular-slider/ngx-slider';

// Filter
import { Ng2SearchPipeModule } from 'ng2-search-filter';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    DataTablesModule,
    CardModule,
    NgbModule,
    RouterModule.forChild([]),
    NgxSliderModule,
    Ng2SearchPipeModule,
    MatSliderModule,
    Ng2SearchPipeModule,
    NgMultiSelectDropDownModule,
  ],
  declarations: [
    DatatableComponent,
    StartEndDateComponent,
    DropdownComponent,
    ExpenseBasicDetailsComponent,
    ExpenseApprovalDetailsComponent,
    ExpenseInvoiceDetailsComponent,
    ExpensePaymentDetailsComponent,
    ExpenseReimbursementDetailsComponent,
    PriceBreakupGroupComponent,
    PriceBreakupBanquetComponent,
    SearchModalComponent,
    // PriceBreakupComponent,
  ],
  exports: [
    DatatableComponent,
    StartEndDateComponent,
    DropdownComponent,
    ExpenseBasicDetailsComponent,
    ExpenseApprovalDetailsComponent,
    ExpenseInvoiceDetailsComponent,
    ExpensePaymentDetailsComponent,
    ExpenseReimbursementDetailsComponent,
    SearchModalComponent,
  ],
})
export class SharedModule {}
